import * as Configuration from '../../../app.constants.js';

/**
 * @deprecated
 * migrated in pushbox.service.ts
 */
export class PushboxService {
  constructor($http) {
    this.$http = $http;
  }

  /**
   * @deprecated migrated
   */
  getTodayCounters(companyId) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/push-mode/today-counters';
    return this.$http.get(url);
  }

  static PushboxFactory($http) {
    return new PushboxService($http);
  }
}
PushboxService.PushboxFactory.$inject = ['$http'];
